var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 44,
    fill: "none",
    viewBox: "0 0 36 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    stroke: "#FD671A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m18 40-.8.7h0v-.2A336.8 336.8 0 0 1 4.8 25.2c-1-1.6-1.4-2.8-1.7-4L3 17.8A15 15 0 0 1 18 3a15 15 0 0 1 15 14.8 14 14 0 0 1-1.9 7.4l-2.6 3.6A230.6 230.6 0 0 1 19 40.5l-.1.1h0L18 40Zm0 0 .8.7a1 1 0 0 1-1.6 0l.8-.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAF3DD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m18.4 22.8-5.2 2.7 1-5.7-4.2-4 5.8-.9 2.6-5.1 2.6 5.1 5.8.9-4.2 4 1 5.7-5.2-2.7Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 18,
    x2: 18,
    y1: 4,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD671A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#950A4D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPin);
export default __webpack_public_path__ + "static/media/bigPin.7ec2ef16e62cdf9eb8ff424b7a51c92c.svg";
export { ForwardRef as ReactComponent };